// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dj1x","content":"styles_content__9etKU"};